import { useEffect, useRef, useState } from "react";

import { apiClient } from "../api/client.js";
import { useAuth } from "../auth/AuthContext.js";

export function GameSettings() {
  const { selectedVenue } = useAuth();
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [editingEnabled, setEditingEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const venueId = selectedVenue?.id;
  const selection = useRef(venueId);
  selection.current = venueId;
  useEffect(() => {
    let cancelled = false;
    setEnabled(null);
    setBusy(false);
    setMessage("");
    if (!venueId) return;
    apiClient["/api/v1/venue/game-settings"]
      .get({ parameters: { venue_id: venueId }, body: null })
      .then((res) => {
        if (cancelled) return;
        if (res.code === 200) {
          setEnabled(res.body.sound_override !== "muted");
          setEditingEnabled(res.body.editing_enabled);
        } else setMessage("Could not load game settings.");
      })
      .catch(() => {
        if (!cancelled) setMessage("Could not load game settings.");
      });
    return () => {
      cancelled = true;
    };
  }, [venueId]);
  return (
    <main className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Game Settings</h1>
      <label className="flex items-center gap-3">
        <input
          type="checkbox"
          checked={enabled ?? true}
          disabled={
            !venueId ||
            selectedVenue?.role !== "admin" ||
            !editingEnabled ||
            busy ||
            enabled === null
          }
          onChange={async (e) => {
            if (!venueId) return;
            const value = e.target.checked;
            setBusy(true);
            setMessage("");
            try {
              const res = await apiClient["/api/v1/venue/game-settings"].put({
                parameters: { venue_id: venueId },
                body: { sound_override: value ? "enabled" : "muted" },
              });
              if (selection.current !== venueId) return;
              if (res.code === 200) {
                setEnabled(res.body.sound_override !== "muted");
                setMessage("Saved. Connected tables receive settings on their next heartbeat.");
              } else setMessage("Could not save game settings.");
            } catch {
              setMessage("Could not save game settings.");
            } finally {
              setBusy(false);
            }
          }}
        />
        Enable Sound
      </label>
      {!editingEnabled && (
        <p className="text-sm text-text-muted mt-2">
          Sound editing becomes available after the games update.
        </p>
      )}
      {message && (
        <p role="status" className="mt-3">
          {message}
        </p>
      )}
    </main>
  );
}
